/**
 * SectionTitle Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Heading from '../../../atoms/text/Heading';

interface IOwnProps {
  className?: string;
  subtitle?: string;
  title: string;
  textColor?: Color;
}

const classes = new BEM('section-title');

const SectionTitle: React.SFC<IOwnProps> = ({ className, subtitle, textColor, title }: IOwnProps) => {
  return (
    <div {...classes('', '', className)}>
      {subtitle && (
        <Heading
          is="h6"
          {...classes('subtitle')}
          textColor={textColor || 'bw6'}
          noMargin
        >{subtitle}
        </Heading>
      )}
      <Heading
        is="h2"
        WrappedComponent="h2"
        {...classes('title')}
        textColor={textColor || 'bw6'}
        noMargin
      >{title}
      </Heading>
    </div>
  );
};

export default SectionTitle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/SectionTitle/index.tsx